import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";
import moment = require("moment");

export enum EBeneficiaryType {
    GENERIC_BENEFICIARY = 'Beneficiario generico',
    SPECIFIC_BENEFICIARY = 'Beneficiario specifico',
}

export enum EGenericBeneficiary {
    CONIUGE_OR_FIGLI = 'Il coniuge o in mancanza i figli',
    EREDI_LEGITTIMI = 'Eredi legittimi',
    EREDI_TESTAMENTARI = 'Eredi testamentari, in mancanza eredi legittimi',
    FIGLI = 'I figli in parti uguali',
    CONIUGE = 'Il coniuge',
    CONIUGE_AND_FIGLI = 'Il coniuge e i figli in parti uguali',
    GENITORI = 'I genitori in parti uguali',
}

export enum ESpecificBeneficiaryType {
    PERSONA_FISICA = 'Persona fisica',
    PERSONA_GIURIDICA = 'Persona giuridica',
}

const BENEFICIARY_TYPE_CSS = 'mt-2 col-6';

export enum ERelationshipWithSubscriberDesc {
    OCCUPATIONAL = 'Lavorativa o Professionale',
    PARENTAGE = 'Parentela o affine',
    COMMERCIAL = 'Commerciale',
    CORPORATE = 'Societaria',
    CONTRACT = 'Contrattuale',
    OTHER = 'Altro'
}

export const relationshipWithSubscriberOptions = [
    {
        key: 'OCCUPATIONAL',
        value: ERelationshipWithSubscriberDesc.OCCUPATIONAL
    },
    {
        key: 'PARENTAGE',
        value: ERelationshipWithSubscriberDesc.PARENTAGE
    },
    {
        key: 'COMMERCIAL',
        value: ERelationshipWithSubscriberDesc.COMMERCIAL
    },
    {
        key: 'CORPORATE',
        value: ERelationshipWithSubscriberDesc.CORPORATE
    },
    {
        key: 'CONTRACT',
        value: ERelationshipWithSubscriberDesc.CONTRACT
    },
    {
        key: 'OTHER',
        value: ERelationshipWithSubscriberDesc.OTHER
    }
]

export const subject_type_form_template = {
    beneficiaryType: null,
    genericBeneficiary: null,
    specificBeneficiaryType: null
}

export const subject_type_form_validators = {
    beneficiaryType: [Validators.required],
    genericBeneficiary: [Validators.required],
    specificBeneficiaryType: [Validators.required]
}

export const subject_type_form_keys: IFormKey[] = [
    {
        id: 'beneficiary-type-field',
        label: 'Tipologia beneficiario',
        controlName: 'beneficiaryType',
        css: BENEFICIARY_TYPE_CSS,
        type: 'SELECT',
        options: [
            {
                key: EBeneficiaryType.GENERIC_BENEFICIARY,
                value: EBeneficiaryType.GENERIC_BENEFICIARY
            },
            {
                key: EBeneficiaryType.SPECIFIC_BENEFICIARY,
                value: EBeneficiaryType.SPECIFIC_BENEFICIARY
            }
        ]
    },
    {
        id: 'generic-beneficiary-field',
        label: 'Selezione beneficiari',
        controlName: 'genericBeneficiary',
        css: BENEFICIARY_TYPE_CSS,
        type: 'SELECT',
        options: [
            {
                key: EGenericBeneficiary.CONIUGE_OR_FIGLI,
                value: EGenericBeneficiary.CONIUGE_OR_FIGLI
            },
            {
                key: EGenericBeneficiary.EREDI_LEGITTIMI,
                value: EGenericBeneficiary.EREDI_LEGITTIMI
            },
            {
                key: EGenericBeneficiary.EREDI_TESTAMENTARI,
                value: EGenericBeneficiary.EREDI_TESTAMENTARI,
            },
            {
                key: EGenericBeneficiary.FIGLI,
                value: EGenericBeneficiary.FIGLI,
            },
            {
                key: EGenericBeneficiary.CONIUGE,
                value: EGenericBeneficiary.CONIUGE
            },
            {
                key: EGenericBeneficiary.CONIUGE_AND_FIGLI,
                value: EGenericBeneficiary.CONIUGE_AND_FIGLI
            },
            {
                key: EGenericBeneficiary.GENITORI,
                value: EGenericBeneficiary.GENITORI
            },
        ],
        hidden: true
    },
    {
        id: 'specific-beneficiary-type-field',
        label: 'Tipologia Persona',
        controlName: 'specificBeneficiaryType',
        css: BENEFICIARY_TYPE_CSS,
        type: 'SELECT',
        options: [
            {
                key: ESpecificBeneficiaryType.PERSONA_FISICA,
                value: ESpecificBeneficiaryType.PERSONA_FISICA
            },
            {
                key: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
                value: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
            }
        ],
        hidden: true
    }
]

export const residence_form_template = {
    country: null,
    place: {value: null, disabled: true},
    province: {value: null, disabled: true},
    postalCode: {value: null, disabled: true},
    toponym: {value: null, disabled: true},
    address: {value: null, disabled: true},
    addressNumber: {value: null, disabled: true}
}

export const residence_form_validators = {
    country: [Validators.required],
    place: [Validators.required],
    province: [Validators.required],
    postalCode: [Validators.required, Validators.pattern(/^\d{5}$/)],
    toponym: [Validators.required],
    address: [Validators.required],
    addressNumber: [Validators.required]
}

export const residence_form_keys: IFormKey[] = [
    {
        id: 'country-field',
        label: 'Nazione',
        controlName: 'country',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'province-field',
        label: 'Provincia',
        controlName: 'province',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'place-field',
        label: 'Città',
        controlName: 'place',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'postalCode-field',
        label: 'CAP',
        controlName: 'postalCode',
        css: 'col-3'
    },
    {
        id: 'toponym-field',
        label: 'Toponimo (via, corso,...)',
        controlName: 'toponym',
        css: 'col-3'
    },
    {
        id: 'address-field',
        label: 'Indirizzo',
        controlName: 'address',
        css: 'col-3'
    },
    {
        id: 'address-number-field',
        label: 'Numero Civico',
        controlName: 'addressNumber',
        css: 'col-3'
    },
];

export const residence_enabling_map = {
    country: 'province',
    province: 'place',
    place: 'postalCode',
    postalCode: 'toponym',
    toponym: 'address',
    address: 'addressNumber'
}

export const hidden_field_foreign_state = ['province', 'place', 'postalCode'];

export const birth_form_template = {
    birthPlace: {value: null, disabled: true},
    birthProvince: {value: null, disabled: true},
    birthCountry: null,
}

export const birth_form_validators = {
    birthPlace: [Validators.required],
    birthProvince: [Validators.required],
    birthCountry: [Validators.required],
}

export const birth_form_keys: IFormKey[] = [
    {
        id: 'birthCountry-field',
        label: 'Nazione',
        controlName: 'birthCountry',
        css: 'col-3',
        type: 'SELECT',
        options: [],
    },
    {
        id: 'birthProvince-field',
        label: 'Provincia',
        controlName: 'birthProvince',
        css: 'col-3',
        type: 'SELECT',
        options: [],
    },
    {
        id: 'birthPlace-field',
        label: 'Città',
        controlName: 'birthPlace',
        css: 'col-3',
        type: 'SELECT',
        options: [],
    },
]

export const birth_form_enabling_map = {
    birthCountry: 'birthProvince',
    birthProvince: 'birthPlace'
}

export const birth_hidden_field_foreign_state = ['birthProvince', 'birthPlace'];

export const individual_form_template = {
    beneficiaryTypeDesc: {value: 'Morte', disabled: true},
    taxCode: null,
    name: null,
    surname: null,
    birthDate: null,
    citizenship: null,
    sex: null,
    quote: null,
    relationshipWithSubscriber: null
}

export const individual_form_validators = {
    beneficiaryTypeDesc: [Validators.required],
    taxCode: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    name: [Validators.required],
    surname: [Validators.required],
    birthDate: [Validators.required],
    citizenship: [Validators.required],
    sex: [Validators.required],
    quote: [Validators.required, Validators.pattern(/^(100(?:\,0+)?|(?:[1-9][0-9]?|100)(?:\,\d+)?|\d(?:\,\d+))$/)],
    relationshipWithSubscriber: [Validators.required]
}

export const individual_form_keys: IFormKey[] = [
    {
        id: 'beneficiary-type-desc-field',
        label: 'Tipo beneficiario',
        controlName: 'beneficiaryTypeDesc',
        css: 'col-4'
    },
    {
        id: 'name-field',
        label: 'Nome',
        controlName: 'name',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'surname-field',
        label: 'Cognome',
        controlName: 'surname',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'taxCode-field',
        label: 'Codice fiscale',
        controlName: 'taxCode',
        css: 'col-4',
        type: 'INPUT',
        uppercase: true
    },
    {
        id: 'birth-date',
        controlName: 'birthDate',
        label: 'Data di nascita',
        css: 'col-4',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'sex-field',
        label: 'Sesso',
        controlName: 'sex',
        css: 'col-4',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'citizenship-field',
        label: 'Nazionalità',
        controlName: 'citizenship',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'quote-field',
        label: 'Quota',
        controlName: 'quote',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'relationshipWithSubscriber-field',
        label: 'Relazione beneficiario-contraente',
        controlName: 'relationshipWithSubscriber',
        css: 'col-4',
        type: 'SELECT',
        options: relationshipWithSubscriberOptions
    }
]

export const legal_person_form_template = {
    beneficiaryTypeDesc: {value: 'Morte', disabled: true},
    birthDate: null,
    shareCapital: null,
    quote: null,
    relationshipWithSubscriber: null,
    vatCode: null,
    companyName: null
}

export const legal_person_form_validators = {
    beneficiaryTypeDesc: [Validators.required],
    birthDate: [Validators.required],
    shareCapital: [Validators.required, Validators.pattern(/^\d+(\,\d+)?$/)],
    quote: [Validators.required, Validators.pattern(/^(100(?:\,0+)?|(?:[1-9][0-9]?|100)(?:\,\d+)?|\d(?:\,\d+))$/)],
    relationshipWithSubscriber: [Validators.required],
    vatCode: [Validators.required],
    companyName: [Validators.required],
}

export const legal_person_form_keys: IFormKey[] = [
    {
        id: 'beneficiary-type-desc-field',
        label: 'Tipo beneficiario',
        controlName: 'beneficiaryTypeDesc',
        css: 'col-4',
    },
    {
        id: 'company-name-field',
        label: 'Ragione sociale',
        controlName: 'companyName',
        css: 'col-4',
        type: 'INPUT',
    },
    {
        id: 'vatCode-field',
        label: 'P. IVA',
        controlName: 'vatCode',
        css: 'col-4',
        type: 'INPUT',
    },
    {
        id: 'birth-date',
        controlName: 'birthDate',
        label: 'Data di costituzione',
        css: 'col-4',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'shareCapital-field',
        label: 'Capitale sociale',
        controlName: 'shareCapital',
        css: 'col-4',
        type: 'INPUT',
    },
    {
        id: 'quote-field',
        label: 'Quota',
        controlName: 'quote',
        css: 'col-4',
        type: 'INPUT',
    },
    {
        id: 'relationshipWithSubscriber-field',
        label: 'Relazione beneficiario-contraente',
        controlName: 'relationshipWithSubscriber',
        css: 'col-4',
        type: 'SELECT',
        options: relationshipWithSubscriberOptions
    }
]

export const fixed_fields: string[] = ['beneficiaryType', 'genericBeneficiary', 'specificBeneficiaryType'];
export const subject_PF_fields: string[] = ['beneficiaryTypeDesc', 'taxCode', 'birthDate', 'name', 'surname', 'citizenship', 'sex', 'birthNewLine', 'birthPlace', 'birthProvince', 'birthCountry', 'residenceNewLine', 'residenceCountry', 'residencePlace', 'residenceProvince', 'residencePostalCode', 'residenceToponym', 'residenceAddress', 'residenceAddressNumber', 'quote', 'relationshipWithSubscriber', 'communications'];
export const subject_PG_fields: string[] = ['beneficiaryTypeDesc', 'companyName', 'vatCode', 'quote', 'relationshipWithSubscriber', 'communications', 'shareCapital', 'birthDate', 'residenceNewLine', 'residenceCountry', 'residencePlace', 'residenceProvince', 'residencePostalCode', 'residenceToponym', 'residenceAddress', 'residenceAddressNumber'];
